<template>
  <div>
    <Dialog
      :key="dialogKey"
      :visible.sync="showDialog1"
      :style="{ width: '80%', overflowY: 'auto' }"
      :header="'Customer Linked Accounts for ' + customer.custName"
      :modal="true"
      class="p-fluid"
    >
      <div style="min-height: 500px;" v-if="!accountDialog">
        <LinkedAccountsTable
          :accounts="linkedAccounts"
          :loading="loading"
          :removingLink="removingLink"
          @accountClicked="accountClicked"
          @removeLink="askRemoveLink"
        />
      </div>
      <div style="min-height: 500px;" v-else>
        <!-- Account Form -->
        <AccountForm
          :accountDialog="accountDialog"
          :reload="realodAccountDialog"
          :refresh="refreshAccountDialog"
          :accountToEdit="account"
          :customer="customer"
          :disabledArr="disabledArr"
          requestType="customerMBPBranch"
          @close="closeAccountForm"
          @saved="savedAccount"
        />
      </div>

      <template #footer>
        <Button
          label="Okay"
          icon="pi pi-check"
          @click="$emit('close')"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>
    <LinkedAccountRemoveConfirm
      :visible.sync="displayRemoveConfirm"
      :account="removeCandidate"
      @confirm="confirmRemoveLink"
    />
  </div>
</template>

<script>
import LinkedAccountsTable from "./LinkedAccountsTable";
import AccountForm from "./AccountForm";
import LinkedAccountRemoveConfirm from "./LinkedAccountRemoveConfirm";
import linkedAccountsMixin from "./linkedAccountsMixin";

export default {
  mixins: [linkedAccountsMixin],
  components: {
    LinkedAccountsTable,
    AccountForm,
    LinkedAccountRemoveConfirm
  },
  created() {
    this.setupComponent();
  },
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    reloadDialog: {
      type: Number,
      required: false
    },
    customer: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    dialogKey1: 0
  }),
  computed: {
    loading() {
      if (this.linkedAccounts && this.linkedAccounts[0]) {
        return false;
      } else {
        if (this.requesting) {
          return true;
        } else {
          return false;
        }
      }
    },
    dialogKey: {
      set() {
        this.dialogKey1++;
      },
      get() {
        return "dialogKey-" + this.dialogKey1.toString();
      }
    },
    showDialog1: {
      set(val) {
        if (!val) {
          this.$emit("close");
        }
      },
      get() {
        return this.showDialog;
      }
    }
  },
  watch: {
    linkedAccounts(val) {},
    reloadDialog() {
      this.dialogKey = this.dialogKey1 + 1;
      this.setupComponent();
    }
  },
  methods: {
    setupComponent() {
      //
      this.removingLink = {};
      this.assignedCustomerMBPbranches();
    },
  }
};
</script>

<style></style>
